import { useTranslate } from "@ur/react-hooks"
import { SeverityCategory } from "./types"
import { InfringementSeverities } from "./consts"

export function useInfringementsFilter() {}

export function useInfringementSeverityOptions() {
    const translations = useTranslate({
        severityGrades: {
          MINOR: 'infringements.minor-infringement',
          SERIOUS: 'infringements.serious-infringement',
          VERY_SERIOUS: 'infringements.very-serious-infringement',
          MOST_SERIOUS: 'infringements.most-serious-infringement',
        }
    })
    const severityOptions = [
        { value: InfringementSeverities.MINOR, label: translations.severityGrades.MINOR},
        { value: InfringementSeverities.SERIOUS, label: translations.severityGrades.SERIOUS},
        { value: InfringementSeverities.VERY_SERIOUS, label: translations.severityGrades.VERY_SERIOUS},
        { value: InfringementSeverities.MOST_SERIOUS, label: translations.severityGrades.MOST_SERIOUS},
      ] as {
        value: SeverityCategory
        label: string
      }[]
    
    return severityOptions
}